"use client";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { Popup, Spinner } from "@akashnetwork/ui/components";

export type LoadingState =
  | "waitingForApproval"
  | "broadcasting"
  | "searchingProviders"
  | "creatingDeployment"
  | "updatingDeployment"
  | "creatingLease"
  | "closingDeployment"
  | "depositingDeployment"
  | "mintingACT";

type Props = {
  state?: LoadingState;
  onClose?: () => void;
  children?: ReactNode;
};

export const TransactionModal: React.FunctionComponent<Props> = ({ state, onClose }) => {
  const intl = useIntl();

  const TITLES: Record<LoadingState, string> = {
    waitingForApproval: intl.formatMessage({ id: "layout.transactionmodal.title.waitingforapproval", defaultMessage: "Waiting for tx approval" }),
    broadcasting: intl.formatMessage({ id: "layout.transactionmodal.title.broadcasting", defaultMessage: "Transaction Pending" }),
    searchingProviders: intl.formatMessage({ id: "layout.transactionmodal.title.searchingproviders", defaultMessage: "Searching Providers" }),
    creatingDeployment: intl.formatMessage({ id: "layout.transactionmodal.title.creatingdeployment", defaultMessage: "Creating Deployment" }),
    updatingDeployment: intl.formatMessage({ id: "layout.transactionmodal.title.updatingdeployment", defaultMessage: "Updating Deployment" }),
    creatingLease: intl.formatMessage({ id: "layout.transactionmodal.title.creatinglease", defaultMessage: "Creating Lease" }),
    closingDeployment: intl.formatMessage({ id: "layout.transactionmodal.title.closingdeployment", defaultMessage: "Closing Deployment" }),
    depositingDeployment: intl.formatMessage({ id: "layout.transactionmodal.title.depositingdeployment", defaultMessage: "Depositing Deployment" }),
    mintingACT: intl.formatMessage({ id: "layout.transactionmodal.title.mintingact", defaultMessage: "Minting ACT" })
  };

  const DESCRIPTIONS: Partial<Record<LoadingState, string>> = {
    waitingForApproval: intl.formatMessage({ id: "layout.transactionmodal.desc.waitingforapproval", defaultMessage: "APPROVE OR REJECT TX TO CONTINUE..." }),
    broadcasting: intl.formatMessage({ id: "layout.transactionmodal.desc.broadcasting", defaultMessage: "BROADCASTING TRANSACTION..." }),
    mintingACT: intl.formatMessage({ id: "layout.transactionmodal.desc.mintingact", defaultMessage: "This should only take a moment" })
  };

  return state ? (
    <Popup
      fullWidth
      open={!!state}
      variant="custom"
      title={<div className="text-center">{TITLES[state]}</div>}
      actions={[]}
      onClose={onClose}
      maxWidth="xs"
      enableCloseOnBackdropClick={false}
      hideCloseButton
    >
      <div className="p-4 text-center">
        <div className="mb-12 mt-8">
          <Spinner size="large" className="flex justify-center" />
        </div>

        {DESCRIPTIONS[state] && <div className="text-sm text-muted-foreground">{DESCRIPTIONS[state]}</div>}
      </div>
    </Popup>
  ) : null;
};
